import GetCookie from '../GetCookie'

export default class Cookie extends GetCookie {
  private additionalDate(additional: number): Date {
    const nowDate = new Date()
    return new Date(nowDate.getTime() + additional * 1000)
  }

  private cookiePair(name: string, value: string) {
    return `${name}=${value};`
  }

  /**
   * Cookieの作成
   *
   * @param _cookieName
   *   Cookie名
   * @param _value
   *   値
   * @param _maxAge
   *   有効期限
   * @param _path
   *   パス
   * @param _domain
   *   ドメイン
   */
  public setCookie(
    _cookieName: string,
    _value: string,
    _maxAge: number | null = null,
    _path = '/',
    _domain?: string
  ): void {
    let cookieStr = this.cookiePair(_cookieName, _value)
    cookieStr += this.cookiePair('path', _path)
    if (document.location.protocol === 'https:') {
      cookieStr += 'secure;'
    }
    if (_maxAge) {
      cookieStr += this.cookiePair('max-age', _maxAge.toString())
      cookieStr += this.cookiePair(
        'expires',
        this.additionalDate(_maxAge).toUTCString()
      )
    }
    if (_domain) {
      cookieStr += this.cookiePair('domain', _domain)
    }
    document.cookie = cookieStr
  }
}
